// extracted by mini-css-extract-plugin
export default {"container":"note_container__M6KUl","type":"note_type__RT1BA","add_note":"note_add_note__QPH+o","add":"note_add__MAbcU"};